<template>
    <vue-page-transition name="fade-in-down">
      <v-content class="bg-content">
        <div class="about">
          <v-container grid-list-xl fluid style="padding: 30px; margin-top: -10px; z-index: 1;">
            <v-layout row wrap>
              <v-flex sm12 xs12 md12 lg12>
                <v-card class="theme-bg-card-2 card-animate-2">
                  <v-img height="200" src="../assets/assets/CFBG2.png"></v-img>
                  <v-row style="margin:2.5%;position:absolute; top: 10px">
                    <v-list-item>
                      <v-list-item-avatar size="100">
                        <img v-bind:src="userInfo.profilePic" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="title"
                          style="margin-top:10px; color: #ffffff"
                          >{{ userInfo.name }}</v-list-item-title>
                        <v-list-item-subtitle style=" color: #ffffff"
                          >{{ userInfo.position }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-row>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <br />
<!-- 
                                                                                <br />
          <ChatGPTAgent />
                    <br />
          <ArtistBookingInfo />
          <br /> -->
        
          <!-- <v-container grid-list-xl fluid style="padding: 25px; margin-top: 20px;" class="card-animate-2">
         <v-layout row wrap class="container-fonts" style="padding: 20px;">

<v-container fluid>
  <v-row dense>
    <v-col
      v-for="app in dashboardApps"
      :key="app.name"
      cols="12"
      sm="6"
      md="4"
      lg="2"
      xl="2"
      class="d-flex"
    >
      <v-card
        elevation="3"
        class="chart-content flex-grow-1"
        :href="app.link"
        target="_self"
      >
        <v-img
          :src="app.icon"
          class="mx-auto my-4"
          max-width="80"
          contain
        ></v-img>

        <div class="chart-title">{{ app.name }}</div>
        <v-divider></v-divider>
        <div class="chart-text">{{ app.description }}</div>
        <v-divider></v-divider>
        <div class="d-flex flex-wrap justify-center pa-2">
          <v-chip
            v-for="integration in app.integrations"
            :key="integration"
            color="blue lighten-4"
            small
            class="ma-1 integration-chip"
            label
          >
            {{ integration }}
          </v-chip>

       <v-tooltip right max-width="400">
  <template v-slot:activator="{ on }">
    <v-icon
      small
      color="cyan lighten-2"
      class="ml-2 futuristic-tooltip-icon"
      v-on="on"
    >
      mdi-information-outline
    </v-icon>
  </template>
  <div class="chip-desc2">
    <strong>How to Use:</strong><br>
    <ol class="tooltip-steps">
      <li>Step 1: Open the {{ app.name }} tool.</li>
      <li>Step 2: {{ app.instructions }}</li>
      <li>Step 3: Review results & insights.</li>
    </ol>
  </div>
</v-tooltip>

        </div>
      </v-card>
    </v-col>
  </v-row>
</v-container>

          </v-layout>
      </v-container> -->
          
<v-container grid-list-xl fluid class="dashboard-container">
  <v-layout row wrap class="container-fonts">
    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="app in dashboardApps"
          :key="app.name"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="3"
          class="d-flex"
        >
<v-card
  elevation="10"
  class="chart-content futuristic-card flex-grow-1"
  @click="onCardClick($event, app.link)"
  :style="rippleStyle"
  ripple
>


<v-img
  :src="app.icon"
  class="mx-auto my-4 futuristic-img"
  max-width="80"
  contain
  @mouseover="playPopSound"
/>


            <div class="chart-title">{{ app.name }}</div>
            <v-divider class="my-1"></v-divider>
            <br />
            
            <div class="chart-text">{{ app.description }}</div>
            <v-divider class="my-1"></v-divider>

            <div class="d-flex flex-wrap justify-center pa-2">
              <v-chip
                v-for="integration in app.integrations"
                :key="integration"
                color="blue lighten-4"
                small
                class="ma-1 integration-chip"
                label
              >
                {{ integration }}
              </v-chip>

              <v-tooltip right max-width="600">
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="cyan lighten-2"
                    class="ml-2 futuristic-tooltip-icon hover-glow"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <div class="chip-desc2">
                  <strong>How to Use:</strong><br />
                  <ol class="tooltip-steps">
                    <li>Step 1: Open the {{ app.name }} tool.</li>
                    <li>Step 2: {{ app.instructions }}</li>
                    <li>Step 3: Review results & insights.</li>
                  </ol>
                </div>
              </v-tooltip>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</v-container>


    </div>
     
        <v-dialog v-model="showConfirmation" max-width="290">
          <v-card class="theme-bg-card-2">
            <v-card-title class="text-h5">
              Are you sure you want to delete this user?
            </v-card-title>
            <v-card-text v-if="itemToBeDeleted._id">
              User: {{ itemToBeDeleted.userName }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="showConfirmation = false">
                Disagree
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :loading="loading3"
                :disabled="loading3"
                @click="deleteUser()"
              >
                Agree
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-overlay :value="overlay" opacity="0.98" z-index="9">
          <v-card
            v-scroll.self="onScroll"
            style="background-color: rgba(48, 64, 87, 0.8)"
            class="overflow-y-auto popup-container theme-bg-card-3"
          >
            <v-layout row wrap fluid>
              <v-flex xs12 sm12 md12>
                <v-list-item class="mb-margin">
                  <v-list-item-content>
                    <v-form ref="userform" lazy-validation aria-autocomplete="off">
                      <v-banner
                        class="justify-center text-h5 font-weight-light"
                        sticky
                      >
                        <v-avatar size="70">
                          <img src="@/assets/UserIcon.png" />
                        </v-avatar>
                        Users
                      </v-banner>
                      <h6 class="display-6 font-weight-thin">
                        General Information
                      </h6>
                      <v-row>
                        <v-text-field
                          v-model="formFields.fullName"
                          class="mg-lr14"
                          label="First Name"
                          outlined
                          required
                        ></v-text-field>
                      </v-row>
                      <v-row>
                        <v-select
                          v-model="formFields.department"
                          class="mg-lr14"
                          :items="department"
                          label="Department"
                          outlined
                          required
                        ></v-select>
                        <v-select
                          v-model="formFields.position"
                          class="mg-lr14"
                          :items="position"
                          label="Position"
                          multiple
                          outlined
                        ></v-select>
                        <v-select
                          v-model="formFields.role"
                          class="mg-lr14"
                          :items="role"
                          label="Role"
                          multiple
                          outlined
                        ></v-select>
                      </v-row>
                      <v-row>
                        <v-text-field
                          v-model="formFields.mobile"
                          class="mg-lr14"
                          label="Mobile"
                          outlined
                          required
                        ></v-text-field>
                        <v-text-field
                          v-model="formFields.email"
                          class="mg-lr14"
                          label="Company Email"
                          outlined
                          required
                        ></v-text-field>
                        <v-text-field
                          v-model="formFields.extension"
                          class="mg-lr14"
                          label="Extension"
                          outlined
                          required
                        ></v-text-field>
                      </v-row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mx-2" color="red" outlined @click="resetForm()"
                          >Cancel</v-btn
                        >
                        <v-btn
                          class="mx-2"
                          color="green"
                          v-if="!editForm"
                          :loading="loading3"
                          :disabled="loading3"
                          outlined
                          @click="submitForm"
                          >Save</v-btn
                        >
                        <v-btn
                          class="mx-2"
                          color="green"
                          v-if="editForm"
                          :loading="loading3"
                          :disabled="loading3"
                          outlined
                          @click="updateUser"
                          >Update</v-btn
                        >
                      </v-card-actions>
                    </v-form>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-layout>
          </v-card>
        </v-overlay>
      </v-content>
    </vue-page-transition>
  </template>
  
  <script>
  import { mapMutations } from 'vuex';
  // import ChatGPTAgent from '../components/ChatGPTAgent.vue';
  // import ArtistBookingInfo from './ArtistBookingInfo.vue';
  export default {
    name: 'Users',
    components: {
      // ChatGPTAgent,
      // ArtistBookingInfo
    },
    data() {
      return {
        dashboard: {},
        commandsList: [
          {
            title: 'Add User',
            icon: 'mdi-account-plus',
            action: 'addUser',
          },
        ],
        scrollInvoked: 0,
        department: [
          'Telemarketing',
          'Marketing',
          'Operations',
          'Sales',
          'Finance',
          'Human Resources',
          'Customer Service',
        ],
        position: [
          'Sales Associate',
          'Senior Sales Associate',
          'Manager',
          'Sales Manager',
          'Chief Executive Officer',
          'Chief Sales Officer',
          'Chief Operations Officer',
        ],
        role: ['Administrator', 'Manager', 'Employee', 'Executive'],
        items: [],
        userInfo: JSON.parse(localStorage.getItem('currentUser')) || {}, // Ensure userInfo is available
        usersList: [],
        searchKey: '',
        search: '',
        optionIndex: 0,
        itemToBeDeleted: '',
        loading3: false,
        isLoading: false,
        productLoader: false,
        editForm: false,
        showConfirmation: false,
        overlay: false,
        rows: 100,
        itemsPerPage: 10,
        currentField: 0,
        tableLoader: false,
        date: '',
        players: [],
        clickAudio: null,
        popAudio: null,
        rippleStyle: {},
        submissions: [],
          dashboardApps: [
            {
  name: "Ask AI",
  icon: require("@/assets/AskAI.png"),
  link: "/aidashboard",
  integrations: ["G", "T", "S"],
  description: "GPT 5.1 | AI-powered dashboard for insights.",
  instructions: "View AI-generated insights and analytics using Google, Ticketmaster, and Spotify data."
},
            {
  name: "Artist Analyst",
  icon: require("@/assets/AIANALYST450px.png"),
  link: "/aiartistanalystv2",
  integrations: ["P", "G", "T", "S"],
  description: "NEW GPT 5.1 | AI-powered stats, trends & tour data.",
  instructions: "Analyze artist data, discover patterns, and generate insights using Google, Ticketmaster, Spotify, and AI."
},
            {
  name: "Legacy Analyst",
  icon: require("@/assets/Assistant2.png"),
  link: "/artistanalyst",
  integrations: ["G", "T", "S"],
  description: "GPT 4.2 | AI-powered stats, trends & tour data.",
  instructions: "Analyze artist data, discover patterns, and generate insights using Google, Ticketmaster, Spotify, and AI."
},

{
  name: "Tour Analyst",
  icon: require("@/assets/CodexData.png"),
  link: "/touranalyst",
  integrations: ["G", "T", "S"],
  description: "Visualize & analyze tour routes with AI.",
  instructions: "Visualize and analyze tour routes, patterns, and trends using cross-platform data and AI."
},
{
  name: "Tour Prediction",
  icon: require("@/assets/DashIcon.png"),
  link: "/tourprediction",
  integrations: ["P", "S", "T"],
  description: "Predict artist tours & generate insights.",
  instructions: "Forecast future tours and build acquisition reports using Pollstar, Ticketmaster, and AI."
},
{
  name: "Tour Router",
  icon: require("@/assets/Concierge.png"),
  link: "/tourrouter",
  integrations: ["G", "T", "S"],
  description: "AI-optimized routing for touring.",
  instructions: "Plan optimized artist tour routes by city, date, and venue, enhanced with AI routing."
},

// {
//   name: "Agent Info",
//   icon: require("@/assets/BookingIcon.png"),
//   link: "/artistbooking",
//   integrations: ["G", "T", "S"],
//   description: "Find and manage artist booking information.",
//   instructions: "Search for artist booking details and manage your bookings."
// }
    ],
        formFields: {
          fullName: '',
          department: '',
          position: [],
          role: [],
          mobile: '',
          email: '',
          extension: '',
        },
        modal_date_picker: false,
        form_valid: true,
        headers: [
          {
            text: 'Name',
            value: 'fullName',
            align: 'center',
            sortable: false,
            divider: true,
          },
          {
            text: 'Department',
            value: 'department',
            align: 'center',
            divider: true,
          },
          { text: 'Position', value: 'position', align: 'center', divider: true },
          {
            text: 'Role',
            value: 'role',
            align: 'center',
            divider: true,
          },
          { text: 'Mobile', value: 'mobile', align: 'center', divider: true },
          {
            text: 'Email',
            value: 'email',
            align: 'center',
            divider: true,
          },
          {
            text: 'Extension',
            value: 'extension',
            align: 'center',
            divider: true,
          },
          {
            text: '',
            value: 'controls',
            align: 'center',
            sortable: true,
            divider: true,
          },
        ],
      };
    },
    mounted() {
      this.getUsersList();
      this.userInfo = JSON.parse(localStorage.getItem('currentUser')) || {};
      let profile = JSON.parse(localStorage.getItem('currentUser'));
      this.userInfo = profile;
      // Filter events for logged-in user
      this.leadsEvents = this.leadsList
        .filter((lead) => lead.leadOwner === this.userInfo.email)
        .map((lead) => ({
          title: lead.leadStatus,
          start: lead.callbackDate || lead.leadsDate,
          end: lead.callbackDate || lead.leadsDate,
          accountName: lead.company,
          contactName: `${lead.firstName} ${lead.lastName}`,
          phone: lead.phone,
        }));
      this.$store.commit('SET_SALES_ASSOCIATES', this.salesAssociates);
      this.$store.commit('SET_SENIOR_SALES_ASSOCIATES', this.seniorSalesAssociates);
      this.$store.commit('SET_MANAGER', this.manager);
      this.$store.commit('SET_CHIEF_SALES_OFFICER', this.chiefSalesOfficer);
      this.$store.commit('SET_CHIEF_OPERATIONS_OFFICER', this.chiefOperationsOfficer);
      this.$store.commit('SET_CHIEF_EXECUTIVE_OFFICER', this.chiefExecutiveOfficer);
      this.$store.commit('SET_SALES_MANAGER', this.salesManager);
      this.$store.commit('SET_LEADS_EVENTS', this.leadsEvents);
      this.$store.commit('SET_LEADS_LIST', this.leadsList);
      this.$store.commit('SET_USERS_LIST', this.usersList);
      this.$store.commit('SET_USER_INFO', this.userInfo);
      this.$store.commit('SET_PROFILE', profile);
      this.$store.commit('SET_LEAD_OWNER', this.userInfo.email);
      this.$store.commit('SET_LEAD_OWNER_NAME', this.userInfo.name);
      this.$store.commit('SET_LEAD_OWNER_POSITION', this.userInfo.position);
      this.$store.commit('SET_LEAD_OWNER_PROFILE', this.userInfo.profilePic);
      this.$store.commit('SET_LEAD_OWNER_ID', this.userInfo._id);
      this.$store.commit('SET_LEAD_OWNER_DEPARTMENT', this.userInfo.department);
      this.$store.commit('SET_LEAD_OWNER_ROLE', this.userInfo.role);
      Event.$on('openForm', () => {
        if (this.$route.path !== '/users') {
          return;
        }
        this.readOutLoud('Please fill the following details');
        setTimeout(() => {
          this.readOutLoud('What is the user');
          this.startListining();
        }, 3000);
        this.overlay = true;
      });
      Event.$on('commandReceived', (command) => {
        this.commandsList.push(command);
      });
       Event.$on('editFromRecord', (data) => {
        if (this.$route.path !== '/users') {
          return;
        }
        console.log(data.msg);
        this.editUser(this.usersList[0]);
      });
      Event.$on('searchFromRecord', (data) => {
        if (this.$route.path !== '/users') {
          return;
        }
        this.search = data.msg;
        this.searchUser();
      });
      Event.$on('formDetails', (data) => {
        switch (data.msg) {
          case 'next':
            this.currentField++;
            this.navigateField();
            break;
          case 'previous':
            this.currentField--;
            this.navigateField();
            break;
          case 'submit':
            this.readOutLoud('Please verify your details');
            break;
          case 'verified':
            this.overlay = false;
            this.submitForm();
            break;
          default:
            this.fillForm(data.msg);
            break;
        }
      });
        this.clickAudio = new Audio(require('../assets/audio/ThinClick.wav'));
  this.clickAudio.load();
  this.popAudio = new Audio(require('../assets/audio/pop-up.wav')); // You’ll need to add this file
  this.popAudio.load();
    },
    computed: {
      salesAssociates() {
        return this.usersList
          .filter((user) => user.position.includes('Sales Associate'))
          .map((user) => `${user.fullName}`);
      },
      seniorSalesAssociates() {
        return this.usersList
          .filter((user) => user.position.includes('Senior Sales Associate'))
          .map((user) => `${user.fullName}`);
      },
      manager() {
        return this.usersList
          .filter((user) => user.position.includes('Manager'))
          .map((user) => `${user.fullName}`);
      },
      chiefSalesOfficer() {
        return this.usersList
          .filter((user) => user.position.includes('Chief Sales Officer'))
          .map((user) => `${user.fullName}`);
      },
      chiefOperationsOfficer() {
        return this.usersList
          .filter((user) => user.position.includes('Chief Operations Officer'))
          .map((user) => `${user.fullName}`);
      },
      chiefExecutiveOfficer() {
        return this.usersList
          .filter((user) => user.position.includes('Chief Executive Officer'))
          .map((user) => `${user.fullName}`);
      },
      salesManager() {
        return this.usersList
          .filter((user) => user.position.includes('Sales Manager'))
          .map((user) => `${user.fullName}`);
      },
      isLoggedIn() {
        // Replace with your actual authentication check
        return this.$store.state.isLoggedIn;
      },
    },
    methods: {
    ...mapMutations(['store']),
    initialize() {
      this.usersList = [];
    },
playClickSound() {
  if (this.clickAudio) {
    this.clickAudio.currentTime = 0;
    this.clickAudio.play().catch(() => {});
  }
},
playPopSound() {
  if (this.popAudio) {
    this.popAudio.currentTime = 0;
    this.popAudio.play().catch(() => {});
  }
},

  // playClickSound() {
  //   if (this.clickAudio) {
  //     this.clickAudio.currentTime = 0;
  //     this.clickAudio.play().catch(err => console.warn('Audio play blocked:', err));
  //   }
  // },
  onCardClick(event, link) {
    this.playClickSound();

    // Compute ripple position
    const rect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    this.rippleStyle = {
      '--ripple-x': `${x}px`,
      '--ripple-y': `${y}px`
    };

    // Card click glow
    const card = event.currentTarget;
    card.classList.add('card-pressed');
    setTimeout(() => card.classList.remove('card-pressed'), 200);

    // Navigate
    setTimeout(() => window.open(link, '_self'), 120);
  },
    onScroll() {
      this.scrollInvoked++;
    },
    getEmailByLeadOwner(leadOwner) {
      const user = this.usersList.find((u) => `${u.fullName}` === leadOwner);
      return user ? user.email : '';
    },
    searchUser: async function () {
      if (!this.search) this.getUsersList();
      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;
      this.usersList = json.result;
    },
    getUsersList: async function () {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/all`
      );
      const json = await response.json();
      this.usersList = json.result;
      this.tableLoader = false;
      this.$store.commit('SET_SALES_ASSOCIATES', this.salesAssociates);
      this.$store.commit('SET_SENIOR_SALES_ASSOCIATES', this.seniorSalesAssociates);
    },
    submitForm: async function () {
      if (this.isLoggedIn) {
        this.store({ salesDate: this.salesDate });
        this.players.push(this.formFields.fullName);
        this.submissions.push(this.salesDate);
      }
      this.loading3 = true;
      await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      setTimeout(() => {
        this.readOutLoud('User Created');
        this.getUsersList();
        this.resetForm();
      }, 800);
    },
    deleteConfirmation: function (item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },
    deleteUser: async function () {
      this.loading3 = true;
      await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;
      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getUsersList();
      }, 800);
    },
    editUser: function (data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
      this.formFields.position = Array.isArray(data.position)
        ? data.position
        : [data.position];
      this.formFields.role = Array.isArray(data.role) ? data.role : [data.role];
    },
    updateUser: async function () {
      this.loading3 = true;
      await fetch(
        `${process.env.VUE_APP_NODE_SERVER}users/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getUsersList();
        this.resetForm();
      }, 800);
    },
    resetForm: function () {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.formFields = {
        fullName: '',
        department: '',
        position: [],
        role: [],
        mobile: '',
        email: '',
        extension: '',
      };
    },
    openForm: function () {
      this.overlay = true;
      this.items = [];
    },
    startListining: function () {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1250);
    },
    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },
    getDashboard: async function() {
        const rawResponse = await fetch(`${process.env.VUE_APP_NODE_SERVER}analytics/all`);
        const content = await rawResponse.json();
        this.dashboard = content.response;
        console.log(content);
      },
    readOutLoud: function (msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.text = msg;
      speech.lang = 'en-GB';
      window.speechSynthesis.speak(speech);
      this.speak = msg;
    },
    dateCommand: function (msg) {
      let date;
      var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      if (month < 9) {
        month = '0' + month;
      }
      var year = currentDate.getFullYear();
      switch (msg) {
        case 'today':
          date = new Date().toISOString().slice(0, 10);
          break;
        case 'tomorrow':
          date = year + '-' + month + '-' + (day + 1);
          break;
        default:
          msg = msg + ' ' + year;
          date = new Date(msg).toISOString().slice(0, 10);
          break;
      }
      return date;
    },
    fillForm: function (msg) {
      let firstChar = msg.charAt(0).toUpperCase();
      switch (this.currentField) {
        case 0:
          this.formFields.fullName = msg;
          break;
        case 1:
          this.formFields.department = this.department.find(
            (obj) => obj.indexOf(firstChar) != -1
          );
          break;
        case 2:
          this.formFields.position = this.position.find(
            (obj) => obj.indexOf(firstChar) != -1
          );
          break;
        case 3:
          this.formFields.role = this.role.find(
            (obj) => obj.indexOf(firstChar) != -1
          );
          break;
        case 4:
          this.formFields.mobile = msg;
          break;
        case 5:
          this.formFields.email = msg;
          break;
        case 6:
          this.formFields.extension = msg;
          break;
      }
      this.currentField++;
      this.navigateField();
    },
    navigateField: function () {
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Name?');
          break;
        case 1:
          this.readOutLoud('Department?');
          break;
        case 2:
          this.readOutLoud('Position?');
          break;
        case 3:
          this.readOutLoud('Role?');
          break;
        case 4:
          this.readOutLoud('Mobile?');
          break;
        case 5:
          this.readOutLoud('Email?');
          break;
        case 6:
          this.readOutLoud('Extension?');
          break;
      }
      this.startListining();
    },
  }
  };
  </script>
  
  
  
  <style scoped>
  .fade-in-down-enter-active {
  animation: fadeInDown 0.9s ease both;
}
.fade-in-down-leave-active {
  animation: fadeOutUp 0.6s ease both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.dashboard-container {
  padding: 25px;
  margin-top: 20px;
}

/* ✨ Ripple Animation */
.v-card {
  position: relative;
  overflow: hidden;
}

.v-card::after {
  content: "";
  position: absolute;
  background: rgba(0, 255, 255, 0.35);
  border-radius: 50%;
  transform: scale(0);
  opacity: 0;
  pointer-events: none;
  left: var(--ripple-x, 50%);
  top: var(--ripple-y, 50%);
  width: 200%;
  height: 200%;
  transition: transform 0.4s ease, opacity 0.8s ease;
}

.v-card:active::after {
  transform: scale(2.5);
  opacity: 0.5;
}

/* 🎯 Card click effect */
.card-pressed {
  transform: scale(0.96);
  box-shadow: 0 0 20px rgba(0, 255, 255, 0.6) !important;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

/* 🔄 Subtle Pulse Glow on Icon */
/* .futuristic-img {
  transition: transform 0.3s ease, filter 0.3s ease;
  animation: pulse-icon 3s infinite ease-in-out;
} */

.futuristic-img {
    transition: transform 1.5s ease, filter 1.7s ease;
  animation: pulse-icon 3s infinite ease-in-out;
  transform: scale(1.1);
  filter: drop-shadow(0 0 1px rgba(0, 255, 255, 0));
}

@keyframes pulse-icon {
  0%, 100% {
    filter: drop-shadow(0 0 3px rgba(0, 255, 255, 0.434));
  }
  50% {
    filter: drop-shadow(0 0 6px rgba(0, 255, 255, 0.395));
  }
}


.futuristic-card {
  background: rgba(12, 22, 48, 0.442);
  border: 1px solid rgba(0, 255, 255, 0.2);
  backdrop-filter: blur(14px);
  border-radius: 18px;

  /* Apply transition to all animatable properties */
  transition:
    transform 0.6s ease-in-out,
    box-shadow 0.8s ease-in-out,
    background 0.7s ease-in-out,
    border 0.8s ease-in-out,
    filter 0.9s ease-in-out;

  box-shadow: 0 0 10px rgba(0, 255, 255, 0.1);
}

.futuristic-card:hover {
  background: linear-gradient(145deg, rgba(39, 47, 56, 0.94), rgba(24, 54, 102, 0.69));
  transform: scale(1.06); /* No translateY */
  z-index: 10; /* Prevent overlap issues */
  box-shadow: 0 0 24px rgba(0, 255, 255, 0.35);
  border: 2px solid rgba(0, 255, 255, 0.3);
  filter: brightness(1.07);
  animation: pulse-icon 3s infinite ease-in-out;
}

.hover-icon {
    margin-bottom: 2px;
  margin-right: 16px;
  box-shadow: 0 1px 10px #1afffa34;
  transition: transform 0.17s;
}

.hover-icon:hover {
  transform: scale(1.1);
  filter: drop-shadow(0 0 6px #00ffff);
}

.hover-glow {
  transition: transform 0.2s ease, text-shadow 0.2s ease;
}

.hover-glow:hover {
  transform: scale(1.2);
  text-shadow: 0 0 12px #0ff;
}

.chart-content {
    min-height: 70%;
}

.chart-title {
  font-size: 1.4rem;
  color: #c1f9ff;
  font-weight: bold;
  text-shadow: 0 0 4px #0ff;
}

.chart-text {
  font-size: 1rem;
  color: #b0bec5;
  margin-top: 8px;
  font-weight: 300;
}

.integration-chip {
  background: rgba(15, 240, 255, 0.19) !important;
  color: #3c4041 !important;
  font-size: 0.91rem;          
  font-weight: 500;
  border-radius: 11px;
  width: auto;
}

.futuristic-tooltip-icon {
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.futuristic-tooltip-icon:hover {
  color: #16ffe6;
  transform: scale(1.15);
}

.chip-desc2 {
  color: #33ffc6;
  font-size: 1.5rem;
  background: rgba(12, 22, 27, 0);
  padding: 12px 16px;
  border-radius: 12px;
  font-weight: 400;
  max-width: 500px;
    line-height: 1.5;
}

.tooltip-steps {
  margin: 0;
  padding-left: 1.2rem;
}

.tooltip-steps li {
  margin-bottom: 6px;
  font-size: 0.92rem;
}

.tooltip-steps li::marker {
  color: #19baff;
  font-weight: bold;
}

/* Responsive Tweaks */
@media (max-width: 960px) {
  .chart-title {
    font-size: 1.15rem;
  }
  .chart-text {
    font-size: 0.95rem;
  }
}

@media (max-width: 600px) {
  .chart-content {
    padding: 12px 10px;
  }

  .integration-chip {
    font-size: 0.8rem;
  }

  .chart-title {
    font-size: 1rem;
  }
}

  </style>